import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';

export const GET_USER_FEATURE_FLAGS_MESSAGE_TYPE = 'get_user_feature_flags';

export const getUserFeatureFlags = async () =>
  SocketAsFetch.fetch({
    message_type: GET_USER_FEATURE_FLAGS_MESSAGE_TYPE,
  });
